import { useIntl } from 'react-intl';
import { useMemo } from 'react';
import { pdpTexts } from 'i18n';
import { MotivationFactor } from 'constants/pdp';

interface MotivationFactorOption {
  id: MotivationFactor;
  name: string;
  description: string;
}

const useMotivationFactorOptions = (): MotivationFactorOption[] => {
  const { formatMessage } = useIntl();

  return useMemo(
    () => [
      {
        id: MotivationFactor.COMPENSATION,
        name: formatMessage(pdpTexts.motivationFactorCompensation),
        description: formatMessage(
          pdpTexts.motivationFactorCompensationDescription,
        ),
      },
      {
        id: MotivationFactor.TEAM_OF_TRUST,
        name: formatMessage(pdpTexts.teamOfTrust),
        description: formatMessage(pdpTexts.teamOfTrustDescription),
      },
      {
        id: MotivationFactor.TEAM_OF_PROFESSIONALS,
        name: formatMessage(pdpTexts.teamOfProfessionals),
        description: formatMessage(pdpTexts.teamOfProfessionalsDescription),
      },
      {
        id: MotivationFactor.WORK_ENVIRONMENT,
        name: formatMessage(pdpTexts.workEnvironment),
        description: formatMessage(pdpTexts.workEnvironmentDescription),
      },
      {
        id: MotivationFactor.WELL_STRUCTURED_ENVIRONMENT,
        name: formatMessage(pdpTexts.wellStructuredEnvironment),
        description: formatMessage(
          pdpTexts.wellStructuredEnvironmentDescription,
        ),
      },
      {
        id: MotivationFactor.RECOGNITION,
        name: formatMessage(pdpTexts.recognition),
        description: formatMessage(pdpTexts.recognitionDescription),
      },
      {
        id: MotivationFactor.CHALLENGE,
        name: formatMessage(pdpTexts.challenge),
        description: formatMessage(pdpTexts.challengeDescription),
      },
      {
        id: MotivationFactor.POWER_IMPACT,
        name: formatMessage(pdpTexts.powerImpact),
        description: formatMessage(pdpTexts.powerImpactDescription),
      },
      {
        id: MotivationFactor.CHANGES,
        name: formatMessage(pdpTexts.changes),
        description: formatMessage(pdpTexts.changesDescription),
      },
      {
        id: MotivationFactor.CREATIVITY_AUTONOMY,
        name: formatMessage(pdpTexts.creativityAutonomy),
        description: formatMessage(pdpTexts.creativityAutonomyDescription),
      },
      {
        id: MotivationFactor.SELF_DEVELOPMENT_GROWTH,
        name: formatMessage(pdpTexts.selfDevelopmentGrowth),
        description: formatMessage(pdpTexts.selfDevelopmentGrowthDescription),
      },
      {
        id: MotivationFactor.USEFUL_MEANINGFUL_JOB,
        name: formatMessage(pdpTexts.usefulMeaningfulJob),
        description: formatMessage(pdpTexts.usefulMeaningfulJobDescription),
      },
    ],
    [formatMessage],
  );
};

export default useMotivationFactorOptions;
